module.exports = __webpack_public_path__ + "static/media/tums.caca5cee.png";